export default "__VITE_ASSET__19ef59a7__"